import { useState } from "react";

import { TestLibraryPanel } from "./TestLibraryPanel";
import { TestBuilderPanel } from "./TestBuilderPanel";
// The Questions sub-view is gone: step one of a sitting is now the
// static application form. QuestionLibraryPanel is still on disk and
// still works -- see CLAUDE.md, "Inert code kept on purpose".
// import { QuestionLibraryPanel } from "./QuestionLibraryPanel";

type SubView = "tests" | "library";

const SUB_VIEWS: { key: SubView; label: string; cy: string }[] = [
  { key: "tests", label: "Tests", cy: "tests-sub-tests" },
  { key: "library", label: "Case library", cy: "tests-sub-library" },
];

/**
 * Admin → Tests.
 *
 * Two sub-views behind one tab, matching how AdminPage already does
 * tabbing (local state, not routes) so the admin console keeps one
 * navigation model rather than growing a second.
 */
export function TestsPanel() {
  const [view, setView] = useState<SubView>("tests");

  return (
    <div data-cy="tests-panel">
      <div className="mb-5 flex gap-1 border-b border-border">
        {SUB_VIEWS.map((v) => (
          <button
            key={v.key}
            type="button"
            data-cy={v.cy}
            onClick={() => setView(v.key)}
            className={[
              "-mb-px border-b-2 px-4 py-2 text-sm transition-colors",
              view === v.key
                ? "border-accent font-semibold text-accent"
                : "border-transparent text-foreground-muted hover:text-foreground",
            ].join(" ")}
          >
            {v.label}
          </button>
        ))}
      </div>

      {view === "tests" && <TestBuilderPanel />}
      {view === "library" && <TestLibraryPanel />}
    </div>
  );
}
